import type { FaireProductEntity } from "../../entity_types/product";

export const p_18agd91ybd: FaireProductEntity = {
  token: "p_18agd91ybd",
  type: "product",
  name: "Whiskey Barrel - Bourbon BBQ Sauce",
  brandToken: "b_942a3lwgm1",
  brandName: "PS Seasoning",
  imageUrl:
    "https://cdn.faire.com/fastly/eea25a0768f290968619d8220f7acbafc76fce86d89599897bd7c3316b581a42.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/258cbfcb5412590bec98adbe6fe9893a46611fb6e09e1d7e62406da00d895423.jpeg",
    "https://cdn.faire.com/fastly/2df0defe9d7e600fc6bd25d0932ffa01d8ed70a55fddb528af54bb37b0761a65.jpeg",
    "https://cdn.faire.com/fastly/f77e59df9739271830e45f4ee38ec8e8d72fa70d13b025790bc77e13b5d800d0.jpeg",
    "https://cdn.faire.com/fastly/e239d486e11c765f34f9ab15e6a38cb3f924f93ca911ca9ee2c078efbefbb42b.jpeg",
  ],
  priceDollars: 6.99,
  description:
    "Smokin' Barrel.\n\nJust like your BBQ skills, some things get better with age. That’s why we infused our classic tangy ‘que sauce with smoky notes of barrel-aged bourbon, sticky molasses and brown sugar for flavor so good, you’ll want to drink it straight from the jar. Not everyone is a master chef, but we should all eat like one.\n\n𝐆𝐫𝐞𝐚𝐭 𝐨𝐧:\n\n• Baby Back Ribs\n• Tri Tip\n• Pulled Pork\n• BBQ Chicken\n• Beans",
  tags: [],
  msrpDollars: 9.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:08.205Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
